export default {"src":"/_next/static/media/rotate-icon.d9099975.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};